var render, staticRenderFns
import script from "./CapacityChart.vue?vue&type=script&lang=js&"
export * from "./CapacityChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a04e00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a04e00')) {
      api.createRecord('36a04e00', component.options)
    } else {
      api.reload('36a04e00', component.options)
    }
    
  }
}
component.options.__file = "src/components/dashboard/analytics/CapacityChart.vue"
export default component.exports